module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"videoProcessingFailed":"Sorry, we were unable to process the video"}}')
  delete Component.options._Ctor
}
